import { render, staticRenderFns } from "./HospitalTimings.vue?vue&type=template&id=5ed21aef"
import script from "./HospitalTimings.vue?vue&type=script&lang=js"
export * from "./HospitalTimings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports